module.exports = __webpack_public_path__ + "img/generation_disable.20002567.png";